export const LANGUAGES = [
  { code: "en", name: "English", native: "English" },
  { code: "zh-CN", name: "Mandarin", native: "简体中文" },
  { code: "zh-HK", name: "Cantonese", native: "繁體中文" },
  { code: "ar", name: "Arabic", native: "العربية", rtl: true },
  { code: "vi", name: "Vietnamese", native: "Tiếng Việt" },
  { code: "pa", name: "Punjabi", native: "ਪੰਜਾਬੀ" },
  { code: "el", name: "Greek", native: "Ελληνικά" },
  { code: "it", name: "Italian", native: "Italiano" },
  { code: "hi", name: "Hindi", native: "हिन्दी" },
  { code: "es", name: "Spanish", native: "Español" },
  { code: "ne", name: "Nepali", native: "नेपाली" },
  { code: "af", name: "Afrikaans", native: "Afrikaans" },
];
